const mutations = {
    start: 'start',
    stop: 'stop',
    reset: 'reset',
};

export default mutations;
